import React, { useContext } from 'react';
import { S3_HOSTNAME } from '../constant/hostname';
import { LanguageContext } from '../contexts/LanguageProvider';
import { LANGUAGES } from '../constant/languages';

const ArticleSubmission: React.FC = () => {
  const filePath = '/app/format/%E6%8A%95%E7%A8%BF%E3%83%95%E3%82%A9%E3%83%BC%E3%83%9E%E3%83%83%E3%83%88.docx';
  const email = 'k4i4t1a1@scitec-pro.jp'; // メールアドレス
  const { language } = useContext(LanguageContext);
  const isJa = language === LANGUAGES.JA;

  const handleDownload = () => {
    // S3のURLにアクセスしてファイルをダウンロード
    window.open(S3_HOSTNAME + filePath, '_blank');
  };

  return (
    <div className="mt-10 p-4 bg-gray-50 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4">{isJa ? "記事投稿" : "Article Submission"}</h2>
      <p className="text-gray-600 mb-4">
        {isJa
          ? "以下より投稿フォーマットをダウンロードし、内容を記載の上、メールアドレスへ添付して送付してください。"
          : "Please download the submission, fill in the details, and send it as an attachment to an email address."}
      </p>
      <button
        onClick={handleDownload}
        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition"
      >
        {isJa ? "投稿フォーマットダウンロード" : "Download format"}
      </button>
      <p className="mt-4">
        <span>{isJa ? "送付先アドレス： " : "email: "}</span>
        <a href={`mailto:${email}`} className="text-blue-500 underline">
          {email}
        </a>
      </p>
    </div>
  );
};

export default ArticleSubmission;
